module.exports = __webpack_public_path__ + "img/cruiser.ef5b17be.png";